import React from "react";
import {CoursePage } from "../components/Course";

const Interior = () => (
  <CoursePage pageTitle={'Interior'} />
);

export default Interior;
